import {DomainSubject} from "./domainSubject";
import {logUtil} from "@repo/lib-common";
const complete='complete';
export class DomReadyStateCompleteSubject extends DomainSubject<Event>{
    name= "DomReadyStateCompleteSubject";
    init=()=>{
        logUtil.consoleLog(`DomReadyStateCompleteSubject init called. document.readyState: ${document.readyState}`);
        if (document.readyState === complete) {
            logUtil.consoleLog(`${this.name} document.readyState is already ${document.readyState}`);
            this.trigger();
            return;
        }
        document.addEventListener("readystatechange", (event) => {
            if (document.readyState === complete) {
                logUtil.consoleLog(`${this.name} document.readyState became ${document.readyState} event:`,event);
                this.trigger();
            }
        });
    }
}
const domReadyStateCompleteSubject=new DomReadyStateCompleteSubject();
domReadyStateCompleteSubject.activate();
export {domReadyStateCompleteSubject};



